import { cn } from '@shared/lib/cn';
import type { MediaLink } from '../types';

export function MediaVideo({
  link,
  className,
}: {
  link: MediaLink | null | undefined;
  className?: string;
}) {
  if (!link?.url) {
    return (
      <div
        className={cn(
          'flex aspect-video items-center justify-center bg-muted text-xs text-muted-foreground',
          className,
        )}
      >
        no video
      </div>
    );
  }
  return <video src={link.url} controls className={className} />;
}
